/* IU Cart 1.4.0: dialog keyboard behavior; all cart actions remain native. */
(() => {
  const drawer = document.getElementById('halo-cart-sidebar');
  if (!drawer) return;
  const close = drawer.querySelector('[data-close-cart-sidebar]');
  let opener = null;
  let wasOpen = document.body.classList.contains('cart-sidebar-show');
  const focusClose = () => {
    if (document.body.classList.contains('cart-sidebar-show')) close.focus({preventScroll:true});
  };
  drawer.addEventListener('transitionend', event => {
    if (event.target === drawer && (document.activeElement === opener || document.activeElement === document.body)) focusClose();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cart-sidebar]');
    if (trigger) opener = trigger;
  }, true);
  new MutationObserver(() => {
    const isOpen = document.body.classList.contains('cart-sidebar-show');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;
    if (isOpen) {
      if (!opener && !drawer.contains(document.activeElement)) opener = document.activeElement;
      requestAnimationFrame(focusClose);
    } else {
      const returnTo = opener?.isConnected && opener.getClientRects().length ? opener :
        [...document.querySelectorAll('[data-cart-sidebar]')].find(element => element.getClientRects().length);
      returnTo?.focus({preventScroll:true});
    }
  }).observe(document.body, {attributes:true, attributeFilter:['class']});
  document.addEventListener('keydown', event => {
    if (!document.body.classList.contains('cart-sidebar-show')) return;
    if (!drawer.contains(document.activeElement) && document.activeElement !== document.body) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close.click();
    } else if (event.key === 'Tab') {
      const controls = [...drawer.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')]
        .filter(element => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }
  }, true);
})();
